import Vue from 'vue';

const self = Vue.prototype;

export function handleErrors(error, reject) {
    const messages = {};

    if (error.response.status === self.$response.UnprocessableEntity) {
        if (error.response.data.errors) {
            parseErrors(error.response.data.errors, messages);
        }
        error.response.messages = messages;
        reject(error);
    } else {
        reject(error);
    }
}

function parseErrors(errors, target) {
    for (let field in errors) {
        if (field.includes('.')) {
            const [nestedField, ...rest] = field.split('.');
            target[nestedField] = target[nestedField] || {};
            parseErrors({ [rest.join('.')]: errors[field] }, target[nestedField]);
        } else {
            target[field] = errors[field][0];
        }
    }
}